import styled from 'styled-components';
import { typeScale, round, truncateLines } from 'core/utils';

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: ${typeScale(3)} ${typeScale(2)};
	padding: ${typeScale(3)} 0;

	@media (min-width: 768px) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const Upsell = styled.div`
	display: grid;

	figure {
		padding-top: 77%;
		border-radius: 8px;
		position: relative;
		margin-bottom: ${typeScale(2)};
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
	}

	button {
		margin-top: auto;
		width: fit-content;
	}
`;

export const Name = styled.h4`
	margin: 0;
	font-size: 16px;
	font-weight: 700;
	line-height: ${round(20/16)};
	margin-bottom: ${typeScale(0.5)};
	${truncateLines(2)}
`;

export const Price = styled.p`
	margin: 0;
	font-size: 12px;
	line-height: ${round(15/12)};
	margin-bottom: ${typeScale(1)};
`;

export const CurrencyCode = styled.span`
	font-weight: 600;
`;
